import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { formatPercentage } from '../../../services/dashboardsService';

const InsightWidget = ({ data }) => {
  const { summary, items = [] } = data || {};

  return (
    <div className="insight-widget-body">
      {summary && <p className="insight-widget-summary">{summary}</p>}
      {items.length > 0 && (
        <ul className="insight-widget-items">
          {items.map((item, idx) => {
            const change = Number(item.change_pct);
            const hasChange = !isNaN(change);
            const isUp = hasChange && change > 0;
            const isDown = hasChange && change < 0;
            const changeClass = isUp ? 'insight-up' : isDown ? 'insight-down' : 'insight-neutral';

            return (
              <li key={idx} className="insight-widget-item">
                <div className="insight-widget-item-main">
                  <span className="insight-widget-item-title">{item.title}</span>
                  {item.value && (
                    <span className="insight-widget-item-value">{item.value}</span>
                  )}
                </div>
                {(hasChange || item.detail) && (
                  <div className="insight-widget-item-meta">
                    {hasChange && (
                      <span className={`insight-widget-item-change ${changeClass}`}>
                        {isUp ? <FaArrowUp /> : isDown ? <FaArrowDown /> : null}
                        {formatPercentage(change)}
                      </span>
                    )}
                    {item.detail && (
                      <span className="insight-widget-item-detail">{item.detail}</span>
                    )}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
      {items.length === 0 && !summary && (
        <div className="insight-widget-empty">Sin datos para mostrar.</div>
      )}
    </div>
  );
};

export default InsightWidget;
